import React, { useState } from 'react'
import CircledButtonWithLabel, { LogoVariants } from './CircledButtonWithLabel'
import TagActionButton from './TagActionButton'
import copyTextToClipboard from '../utils/Clipboard'
import StatusMessage from './StatusMessage'
import { TAG_CLICK_SHARE } from '../../store/analytics/analytics.actionTypes'
import { isPE } from '../Device'
import { useT } from '../i18n/T'
import { useTemporaryVisible } from './useTemporaryVisible'

// webpack:BrowserOnly
export const ShareUrlButton = ({
  title = 'Mappy',
  description = '',
  logoVariant = LogoVariants.sharpDarkGreyBorder
}) => {
  const [statusText, setStatusText] = useState()
  const [visible, setVisible] = useTemporaryVisible()
  const msgCopyOK = useT('share.ok')
  const msgCopyKO = useT('share.ko')

  const onClick = () => {
    const hasShareSupport = navigator.share

    if (hasShareSupport && isPE()) {
      navigator
        .share({
          title,
          text: description,
          url: location.href
        })
        .catch(err => {
          // Ignore user share cancel
          if (err.name !== 'AbortError') throw err
        })
    } else {
      copyTextToClipboard(location.href)
        .then(() => {
          setStatusText(msgCopyOK)
        })
        .catch(err => {
          console.error('error', err)
          setStatusText(msgCopyKO)
        })
        .finally(() => {
          setVisible(true)
        })
    }
  }

  return (
    <>
      <TagActionButton type={TAG_CLICK_SHARE} deferClick onClick={onClick}>
        <CircledButtonWithLabel svgId="avion-papier" label="share.action" logoVariant={logoVariant} />
      </TagActionButton>
      <StatusMessage message={statusText} visible={visible} />
    </>
  )
}

export default ShareUrlButton
